import { http, camelify } from '../rest';

export function fetch(http, camelify, demo) {
  return {
    async execute(accountId, startDate) {
      let data;
      if (demo) {
        const file = await import('./fetchInvestmentAccount.data');
        data = file.default;
      } else {
        const startDateParam = startDate ? `?start_date=${startDate}` : '';
        data = (await http.get(`/investment_accounts/${accountId}${startDateParam}`)).data;
      }
      return camelify(data);
    },
  };
}

export default fetch(http, camelify, process.env.DEMO);
